import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import styles from './ProductList-tw-styles';
import FacetPanel from './FacetPanel';
import FacetPanelRadio from './FacetPanelRadio';
import PLPStore from '../../../store/PLPStore';

class ProductCategoryFilterMobile extends React.Component {
  handleCheck = (e, t, ftr) => {
    if (e.target.checked) {
      PLPStore.addFiltersWithoutQuery(t, ftr);
    } else {
      PLPStore.clearFilterWithoutQuery(t, ftr);
    }
  };
  handleCheckRadio = (e, t, ftr, pageType) => {
    const { handleRadioClickedState } = this.props;
    handleRadioClickedState(true);
    if (e.target.checked) {
      PLPStore.clearFilterByCategory(pageType);
      PLPStore.AddFiltersOnRadio(t, ftr);
    } else {
      PLPStore.clearFilterWithoutQuery(t, ftr);
    }
  };

  render() {
    let { component: ComponentProp, filters, data, router } = this.props;
    const Component = ComponentProp || 'div';
    const pageType =
      data.productListCollection.items &&
      data.productListCollection.items[0].facetCategory;

    if (filters === undefined || !filters) {
      return null;
    }
    return (
      <Component>
        {filters.facetCategories != null &&
          filters.facetCategories != undefined &&
          filters.facetCategories.length &&
          filters.facetCategories.map((filter, i) => {
            return pageType && filter.category_label === pageType.title ? (
              <FacetPanelRadio
                styles={styles}
                filter={filter}
                index={i}
                key={i}
                handleCheck={this.handleCheckRadio}
                {...this.props}
                accordionStyles={styles.accordion}
                pageType={pageType}
                router={router}
              />
            ) : (
              <FacetPanel
                styles={styles}
                filter={filter}
                index={i}
                key={i}
                handleCheck={this.handleCheck}
                {...this.props}
                accordionStyles={styles.accordion}
              />
            );
          })}
      </Component>
    );
  }
}

ProductCategoryFilterMobile.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const ProductCategoryFilterMobile = ({prop = val, component = 'div', className = '' }) =>

export default observer(ProductCategoryFilterMobile);
